import React from 'react'
import bannerBg from '../assets/img/Banners/Ourclients.png';
import PageBanner from '../Components/PageBanner';
 
import CompanyLogos from '../Components/Hero/CompanyLogos';
const Clients = () => {
  return (
    <>
     <PageBanner title='Our clients' bannerBg={bannerBg} currentPage='Our clients' />
      <CompanyLogos/>
    </>
  )
}

export default Clients
